import { render, staticRenderFns } from "./RouterEditComponent.vue?vue&type=template&id=07d07c2c&scoped=true"
import script from "./RouterEditComponent.vue?vue&type=script&lang=js"
export * from "./RouterEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RouterEditComponent.vue?vue&type=style&index=0&id=07d07c2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d07c2c",
  null
  
)

export default component.exports